import PropTypes from "prop-types"
import { MenuItem, ListItemIcon, Typography } from "@mui/material"

export default function HelpItem({ url, title, icon, onClick }) {
  return <MenuItem className="menu-help-item" component="a" href={url} target="_blank" rel="noreferrer" onClick={onClick}>
    <Typography variant="inherit">{title}</Typography>
    {icon && <ListItemIcon>
      {icon}
    </ListItemIcon>}
  </MenuItem>
}

HelpItem.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  onClick: PropTypes.func.isRequired,
}
